import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { motivosPerdasVendasSituacaoes } from '../motivo-perda-venda-situacao';

@Component({
    selector: 'sgt-motivo-perda-venda-situacao-select',
    templateUrl: './motivo-perda-venda-situacao-select.component.html',
    styleUrls: ['./motivo-perda-venda-situacao-select.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => MotivoPerdaVendaSituacaoSelectComponent), multi: true },
    ]
})
export class MotivoPerdaVendaSituacaoSelectComponent {
    /** ID da situação do motivo de perda */
    @Input() ngModel: number;
    /** Ao alterar a situação do motivo de perda */
    @Output() ngModelChange = new EventEmitter<number>();

    /** Situações disponíveis no select */
    @Input() situacoes = motivosPerdasVendasSituacaoes;

    /** Nome do input */
    @Input() name: string;
    /* ID do input */
    @Input() id: string;
    /* Se o valor é obrigatório */
    @Input() required: any;
    /* Se deve desabilitar o input */
    @Input() disabled: boolean;
    /** Se deve setar o focus automaticamente */
    @Input() autofocus = false;
    /** Se pode selecionar nenhuma opção */
    @Input() canSelectNull = true;

    @ViewChild('select') select: ElementRef;

    propagateChange: any = () => {};

    /** Ao alterar a situação */
    onChange(id: number) {
        this.ngModel = id;
        this.ngModelChange.emit(this.ngModel);
        this.propagateChange(this.ngModel);
    }

    /** Seta o focus no select */
    setFocus() {
        jQuery(this.select?.nativeElement).trigger('focus');
    }

    writeValue(value: number) { }

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
